<template>
  <li>
    <div :class="{ bold: isFolder }" @dblclick="makeFolder">
      <span @click="toggle" v-if="isFolder">[{{ isOpen ? "-" : "+" }}]</span>
      <input type="checkbox" v-model="model" :value="item.govcode" />
      {{ item.govname }} ( {{item.count}} )
    </div>
    <ul v-show="isOpen" v-if="isFolder">
      <tree-item
        class="item"
        v-for="(child, index) in item.children"
        :key="index"
        :item="child"
        @make-folder="$emit('make-folder', $event)"
      ></tree-item>
    </ul>
  </li>
</template>

<script>
export default {
  name: "TreeItem",
  props: {
    item: Object,
  },
  data: function () {
    return {
      isOpen: false,
      model: false,
      modelValue: this.item.govcode
    };
  },
  computed: {
    isFolder: function () {
      return this.item.children && this.item.children.length;
    },
  },
  methods: {
    toggle: function () {
      if (this.isFolder) {
        this.isOpen = !this.isOpen;
      }
    },
    makeFolder: function () {
      if (!this.isFolder) {
        this.$emit("make-folder", this.item);
        this.isOpen = true;
      }
    },
  },
  watch:{
    model: function(val) {
      let TreeItem = sessionStorage.getItem('TreeItem');
      //勾選
      if(val){
        if(TreeItem){
          sessionStorage.setItem('TreeItem',  TreeItem + ','+ this.item.govcode)
        } else {
          sessionStorage.setItem('TreeItem', this.item.govcode)
        }
      }
      //取消勾選
      else {
        if(TreeItem){
          let treeArray = TreeItem.split(',');
          if(treeArray.length == 1){
            if(this.item.govcode == treeArray[0]) sessionStorage.removeItem('TreeItem')
          } else {
            sessionStorage.setItem('TreeItem',treeArray.filter(t => t != this.item.govcode).join(','));
          }
        }
      }
    }
  },
};
</script>

<style scoped>
body {
  font-family: Menlo, Consolas, monospace;
  color: #444;
}
.item {
  cursor: pointer;
  display: block;
}
.bold {
  font-weight: bold;
}
ul {
  padding-left: 2em;
  line-height: 1.5em;
  list-style-type: dot;
}
</style>
